import React, { useState } from 'react';

const FONT = '"Nunito","Baloo 2",sans-serif';

// Simple Levenshtein distance (iterative DP)
function levenshtein(a, b) {
  a = (a || '').toLowerCase();
  b = (b || '').toLowerCase();
  if (!a.length) return b.length;
  if (!b.length) return a.length;
  const m = Array.from({ length: a.length + 1 }, () => new Array(b.length + 1).fill(0));
  for (let i = 0; i <= a.length; i++) m[i][0] = i;
  for (let j = 0; j <= b.length; j++) m[0][j] = j;
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const c = a[i - 1] === b[j - 1] ? 0 : 1;
      m[i][j] = Math.min(m[i - 1][j] + 1, m[i][j - 1] + 1, m[i - 1][j - 1] + c);
    }
  }
  return m[a.length][b.length];
}

export default function TypingGame({ payload, onAnswer, disabled }) {
  const [value, setValue] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const submit = () => {
    if (submitted) return;
    const dist = levenshtein(value.trim(), payload.answer);
    const tolerance = payload.tolerance ?? 1;
    const ok = dist <= tolerance;
    setSubmitted(true);
    if (onAnswer) onAnswer({ is_correct: ok, user_answer: value });
  };

  return (
    <div style={{ maxWidth: 540, margin: '0 auto', fontFamily: FONT }}>
      <div
        style={{
          padding: 20,
          background: '#eff6ff',
          border: '2px solid #bfdbfe',
          borderRadius: 14,
          textAlign: 'center',
          minHeight: 200,
        }}
      >
        {payload.image_url ? (
          <img
            src={payload.image_url}
            alt=""
            style={{ maxHeight: 160, borderRadius: 10 }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        ) : null}
        {payload.hint_vi ? (
          <div style={{ marginTop: 12, fontSize: 18, color: '#374151' }}>
            {payload.hint_vi}
          </div>
        ) : null}
        <div style={{ marginTop: 8, fontSize: 13, color: '#6b7280' }}>
          Gõ từ tiếng Anh ({payload.length_hint} chữ cái, bắt đầu bằng &quot;
          {payload.first_letter_hint}&quot;)
        </div>
      </div>

      <div style={{ marginTop: 18, display: 'flex', gap: 10 }}>
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
          disabled={submitted || disabled}
          placeholder="Gõ từ tiếng Anh..."
          style={{
            flex: 1,
            padding: '12px 14px',
            border: '2px solid #d1d5db',
            borderRadius: 10,
            fontSize: 18,
            fontFamily: FONT,
          }}
          autoFocus
        />
        <button
          onClick={submit}
          disabled={submitted || disabled || !value.trim()}
          style={{
            padding: '0 22px',
            background: '#1e40af',
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            fontSize: 16,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          Trả lời
        </button>
      </div>

      {submitted ? (
        <div style={{ marginTop: 14, padding: 12, background: '#f3f4f6', borderRadius: 10 }}>
          <div
            style={{
              fontWeight: 700,
              color:
                levenshtein(value.trim(), payload.answer) <= (payload.tolerance ?? 1)
                  ? '#065f46'
                  : '#991b1b',
            }}
          >
            Đáp án: <code>{payload.answer}</code>
          </div>
          {payload.explanation_vi ? (
            <div style={{ marginTop: 6, color: '#374151' }}>{payload.explanation_vi}</div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
